module.exports = __webpack_public_path__ + "img/restore.1b4d9a76.svg";